import {Hour} from './Hour';
import {Minute} from './Minute';

export type TimeType = `${Hour}:${Minute}`;
